var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Supplier Return Matrix"}},[_c('supplier-return-matrix-filters',{on:{"filtersUpdated":_vm.filtersChangeHandler}}),_c('supplier-return-matrix-table',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }